// extracted by mini-css-extract-plugin
module.exports = {"item":"newsListItemSkeleton_item__17eLy","info":"newsListItemSkeleton_info__2DwTI"};